import React from "react";
import { SANS_3, SANS_2, UI_BODY_SM_DF } from "oolib";

function calculateDaysElapsed(targetDate) {
  const currentDate = new Date();
  const target = new Date(targetDate);
  const diffTime = currentDate - target;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}

const ElapsedDays = ({ value, textComp = "UI_BODY_SM_DF", ...textCompProps }) => {
  const TextComps = {
    SANS_2,
    SANS_3,
    UI_BODY_SM_DF
  };

  const TextComp = TextComps[textComp];

  const days = calculateDaysElapsed(value)

  return (
    <TextComp {...textCompProps}>
      {days} {days===1?"day":"days"}
    </TextComp>
  );
};

export default ElapsedDays;
